﻿import { getSupportedLanguage } from "./language";

export type BestMomentItem = {
  id: string;
  src: string;
  title: string;
  date: string;
  month: string;
  year: string;
  category: "best_moments";
  location: string;
  mood: string;
  description: string;
};

type RawBestMomentItem = BestMomentItem & {
  titleEs: string;
  monthEs: string;
  locationEs: string;
  moodEs: string;
  descriptionEs: string;
};

const rawBestMomentItems: RawBestMomentItem[] = [
  {
    "id": "BEST_202607_01",
    "src": "/gallery/best/optimized/best-2026-07-01-900.webp",
    "title": "July signal 01",
    "titleEs": "Senal de Julio 01",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_02",
    "src": "/gallery/best/optimized/best-2026-07-02-900.webp",
    "title": "July signal 02",
    "titleEs": "Senal de Julio 02",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_03",
    "src": "/gallery/best/optimized/best-2026-07-03-900.webp",
    "title": "July signal 03",
    "titleEs": "Senal de Julio 03",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_04",
    "src": "/gallery/best/optimized/best-2026-07-04-900.webp",
    "title": "July signal 04",
    "titleEs": "Senal de Julio 04",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_05",
    "src": "/gallery/best/optimized/best-2026-07-05-900.webp",
    "title": "July signal 05",
    "titleEs": "Senal de Julio 05",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_06",
    "src": "/gallery/best/optimized/best-2026-07-06-900.webp",
    "title": "July signal 06",
    "titleEs": "Senal de Julio 06",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_07",
    "src": "/gallery/best/optimized/best-2026-07-07-900.webp",
    "title": "July signal 07",
    "titleEs": "Senal de Julio 07",
    "date": "2026-07-01",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_08",
    "src": "/gallery/best/optimized/best-2026-07-08-900.webp",
    "title": "July signal 08",
    "titleEs": "Senal de Julio 08",
    "date": "2026-07-01",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_09",
    "src": "/gallery/best/optimized/best-2026-07-09-900.webp",
    "title": "July signal 09",
    "titleEs": "Senal de Julio 09",
    "date": "2026-07-01",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_10",
    "src": "/gallery/best/optimized/best-2026-07-10-900.webp",
    "title": "July signal 10",
    "titleEs": "Senal de Julio 10",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_11",
    "src": "/gallery/best/optimized/best-2026-07-11-900.webp",
    "title": "July signal 11",
    "titleEs": "Senal de Julio 11",
    "date": "2026-07-01",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_12",
    "src": "/gallery/best/optimized/best-2026-07-12-900.webp",
    "title": "July signal 12",
    "titleEs": "Senal de Julio 12",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_13",
    "src": "/gallery/best/optimized/best-2026-07-13-900.webp",
    "title": "July signal 13",
    "titleEs": "Senal de Julio 13",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_14",
    "src": "/gallery/best/optimized/best-2026-07-14-900.webp",
    "title": "July signal 14",
    "titleEs": "Senal de Julio 14",
    "date": "2026-07-20",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_15",
    "src": "/gallery/best/optimized/best-2026-07-15-900.webp",
    "title": "July signal 15",
    "titleEs": "Senal de Julio 15",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Sky archive",
    "locationEs": "Archivo de cielo",
    "mood": "golden-hour cache",
    "moodEs": "golden-hour cache",
    "description": "A unique sunset frame selected for color, contrast and atmosphere inside the monthly best_moments album.",
    "descriptionEs": "Un atardecer unico elegido por color, contraste y atmosfera dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_16",
    "src": "/gallery/best/optimized/best-2026-07-16-900.webp",
    "title": "July signal 16",
    "titleEs": "Senal de Julio 16",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_17",
    "src": "/gallery/best/optimized/best-2026-07-17-900.webp",
    "title": "July signal 17",
    "titleEs": "Senal de Julio 17",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_18",
    "src": "/gallery/best/optimized/best-2026-07-18-900.webp",
    "title": "July signal 18",
    "titleEs": "Senal de Julio 18",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_19",
    "src": "/gallery/best/optimized/best-2026-07-19-900.webp",
    "title": "July signal 19",
    "titleEs": "Senal de Julio 19",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_20",
    "src": "/gallery/best/optimized/best-2026-07-20-900.webp",
    "title": "July signal 20",
    "titleEs": "Senal de Julio 20",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_21",
    "src": "/gallery/best/optimized/best-2026-07-21-900.webp",
    "title": "July signal 21",
    "titleEs": "Senal de Julio 21",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Sky archive",
    "locationEs": "Archivo de cielo",
    "mood": "golden-hour cache",
    "moodEs": "golden-hour cache",
    "description": "A unique sunset frame selected for color, contrast and atmosphere inside the monthly best_moments album.",
    "descriptionEs": "Un atardecer unico elegido por color, contraste y atmosfera dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_22",
    "src": "/gallery/best/optimized/best-2026-07-22-900.webp",
    "title": "July signal 22",
    "titleEs": "Senal de Julio 22",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Sky archive",
    "locationEs": "Archivo de cielo",
    "mood": "golden-hour cache",
    "moodEs": "golden-hour cache",
    "description": "A unique sunset frame selected for color, contrast and atmosphere inside the monthly best_moments album.",
    "descriptionEs": "Un atardecer unico elegido por color, contraste y atmosfera dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_23",
    "src": "/gallery/best/optimized/best-2026-07-23-900.webp",
    "title": "July signal 23",
    "titleEs": "Senal de Julio 23",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_24",
    "src": "/gallery/best/optimized/best-2026-07-24-900.webp",
    "title": "July signal 24",
    "titleEs": "Senal de Julio 24",
    "date": "2026-07-01",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202607_25",
    "src": "/gallery/best/optimized/best-2026-07-25-900.webp",
    "title": "July signal 25",
    "titleEs": "Senal de Julio 25",
    "date": "2026-07-16",
    "month": "July",
    "monthEs": "Julio",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_01",
    "src": "/gallery/best/optimized/best-2026-05-01-900.webp",
    "title": "May signal 01",
    "titleEs": "Senal de Mayo 01",
    "date": "2026-05-30",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_02",
    "src": "/gallery/best/optimized/best-2026-05-02-900.webp",
    "title": "May signal 02",
    "titleEs": "Senal de Mayo 02",
    "date": "2026-05-31",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_03",
    "src": "/gallery/best/optimized/best-2026-05-03-900.webp",
    "title": "May signal 03",
    "titleEs": "Senal de Mayo 03",
    "date": "2026-05-30",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_04",
    "src": "/gallery/best/optimized/best-2026-05-04-900.webp",
    "title": "May signal 04",
    "titleEs": "Senal de Mayo 04",
    "date": "2026-05-31",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_05",
    "src": "/gallery/best/optimized/best-2026-05-05-900.webp",
    "title": "May signal 05",
    "titleEs": "Senal de Mayo 05",
    "date": "2026-05-01",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_06",
    "src": "/gallery/best/optimized/best-2026-05-06-900.webp",
    "title": "May signal 06",
    "titleEs": "Senal de Mayo 06",
    "date": "2026-05-01",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_07",
    "src": "/gallery/best/optimized/best-2026-05-07-900.webp",
    "title": "May signal 07",
    "titleEs": "Senal de Mayo 07",
    "date": "2026-05-30",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_08",
    "src": "/gallery/best/optimized/best-2026-05-08-900.webp",
    "title": "May signal 08",
    "titleEs": "Senal de Mayo 08",
    "date": "2026-05-01",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_09",
    "src": "/gallery/best/optimized/best-2026-05-09-900.webp",
    "title": "May signal 09",
    "titleEs": "Senal de Mayo 09",
    "date": "2026-05-30",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_10",
    "src": "/gallery/best/optimized/best-2026-05-10-900.webp",
    "title": "May signal 10",
    "titleEs": "Senal de Mayo 10",
    "date": "2026-05-01",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Sky archive",
    "locationEs": "Archivo de cielo",
    "mood": "golden-hour cache",
    "moodEs": "golden-hour cache",
    "description": "A unique sunset frame selected for color, contrast and atmosphere inside the monthly best_moments album.",
    "descriptionEs": "Un atardecer unico elegido por color, contraste y atmosfera dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_11",
    "src": "/gallery/best/optimized/best-2026-05-11-900.webp",
    "title": "May signal 11",
    "titleEs": "Senal de Mayo 11",
    "date": "2026-05-05",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Sky archive",
    "locationEs": "Archivo de cielo",
    "mood": "golden-hour cache",
    "moodEs": "golden-hour cache",
    "description": "A unique sunset frame selected for color, contrast and atmosphere inside the monthly best_moments album.",
    "descriptionEs": "Un atardecer unico elegido por color, contraste y atmosfera dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_12",
    "src": "/gallery/best/optimized/best-2026-05-12-900.webp",
    "title": "May signal 12",
    "titleEs": "Senal de Mayo 12",
    "date": "2026-05-01",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Sky archive",
    "locationEs": "Archivo de cielo",
    "mood": "golden-hour cache",
    "moodEs": "golden-hour cache",
    "description": "A unique sunset frame selected for color, contrast and atmosphere inside the monthly best_moments album.",
    "descriptionEs": "Un atardecer unico elegido por color, contraste y atmosfera dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_13",
    "src": "/gallery/best/optimized/best-2026-05-13-900.webp",
    "title": "May signal 13",
    "titleEs": "Senal de Mayo 13",
    "date": "2026-05-30",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_14",
    "src": "/gallery/best/optimized/best-2026-05-14-900.webp",
    "title": "May signal 14",
    "titleEs": "Senal de Mayo 14",
    "date": "2026-05-01",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_15",
    "src": "/gallery/best/optimized/best-2026-05-15-900.webp",
    "title": "May signal 15",
    "titleEs": "Senal de Mayo 15",
    "date": "2026-05-30",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_16",
    "src": "/gallery/best/optimized/best-2026-05-16-900.webp",
    "title": "May signal 16",
    "titleEs": "Senal de Mayo 16",
    "date": "2026-05-30",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_17",
    "src": "/gallery/best/optimized/best-2026-05-17-900.webp",
    "title": "May signal 17",
    "titleEs": "Senal de Mayo 17",
    "date": "2026-05-01",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Sky archive",
    "locationEs": "Archivo de cielo",
    "mood": "golden-hour cache",
    "moodEs": "golden-hour cache",
    "description": "A unique sunset frame selected for color, contrast and atmosphere inside the monthly best_moments album.",
    "descriptionEs": "Un atardecer unico elegido por color, contraste y atmosfera dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_18",
    "src": "/gallery/best/optimized/best-2026-05-18-900.webp",
    "title": "May signal 18",
    "titleEs": "Senal de Mayo 18",
    "date": "2026-05-30",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_19",
    "src": "/gallery/best/optimized/best-2026-05-19-900.webp",
    "title": "May signal 19",
    "titleEs": "Senal de Mayo 19",
    "date": "2026-05-30",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_20",
    "src": "/gallery/best/optimized/best-2026-05-20-900.webp",
    "title": "May signal 20",
    "titleEs": "Senal de Mayo 20",
    "date": "2026-05-01",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Sky archive",
    "locationEs": "Archivo de cielo",
    "mood": "golden-hour cache",
    "moodEs": "golden-hour cache",
    "description": "A unique sunset frame selected for color, contrast and atmosphere inside the monthly best_moments album.",
    "descriptionEs": "Un atardecer unico elegido por color, contraste y atmosfera dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_21",
    "src": "/gallery/best/optimized/best-2026-05-21-900.webp",
    "title": "May signal 21",
    "titleEs": "Senal de Mayo 21",
    "date": "2026-05-30",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_22",
    "src": "/gallery/best/optimized/best-2026-05-22-900.webp",
    "title": "May signal 22",
    "titleEs": "Senal de Mayo 22",
    "date": "2026-05-01",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Sky archive",
    "locationEs": "Archivo de cielo",
    "mood": "golden-hour cache",
    "moodEs": "golden-hour cache",
    "description": "A unique sunset frame selected for color, contrast and atmosphere inside the monthly best_moments album.",
    "descriptionEs": "Un atardecer unico elegido por color, contraste y atmosfera dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_23",
    "src": "/gallery/best/optimized/best-2026-05-23-900.webp",
    "title": "May signal 23",
    "titleEs": "Senal de Mayo 23",
    "date": "2026-05-01",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_24",
    "src": "/gallery/best/optimized/best-2026-05-24-900.webp",
    "title": "May signal 24",
    "titleEs": "Senal de Mayo 24",
    "date": "2026-05-30",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202605_25",
    "src": "/gallery/best/optimized/best-2026-05-25-900.webp",
    "title": "May signal 25",
    "titleEs": "Senal de Mayo 25",
    "date": "2026-05-30",
    "month": "May",
    "monthEs": "Mayo",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_01",
    "src": "/gallery/best/optimized/best-2026-04-01-900.webp",
    "title": "April signal 01",
    "titleEs": "Senal de Abril 01",
    "date": "2026-04-12",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_02",
    "src": "/gallery/best/optimized/best-2026-04-02-900.webp",
    "title": "April signal 02",
    "titleEs": "Senal de Abril 02",
    "date": "2026-04-04",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_03",
    "src": "/gallery/best/optimized/best-2026-04-03-900.webp",
    "title": "April signal 03",
    "titleEs": "Senal de Abril 03",
    "date": "2026-04-12",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_04",
    "src": "/gallery/best/optimized/best-2026-04-04-900.webp",
    "title": "April signal 04",
    "titleEs": "Senal de Abril 04",
    "date": "2026-04-12",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_05",
    "src": "/gallery/best/optimized/best-2026-04-05-900.webp",
    "title": "April signal 05",
    "titleEs": "Senal de Abril 05",
    "date": "2026-04-12",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_06",
    "src": "/gallery/best/optimized/best-2026-04-06-900.webp",
    "title": "April signal 06",
    "titleEs": "Senal de Abril 06",
    "date": "2026-04-12",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_07",
    "src": "/gallery/best/optimized/best-2026-04-07-900.webp",
    "title": "April signal 07",
    "titleEs": "Senal de Abril 07",
    "date": "2026-04-12",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_08",
    "src": "/gallery/best/optimized/best-2026-04-08-900.webp",
    "title": "April signal 08",
    "titleEs": "Senal de Abril 08",
    "date": "2026-04-04",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_09",
    "src": "/gallery/best/optimized/best-2026-04-09-900.webp",
    "title": "April signal 09",
    "titleEs": "Senal de Abril 09",
    "date": "2026-04-04",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_10",
    "src": "/gallery/best/optimized/best-2026-04-10-900.webp",
    "title": "April signal 10",
    "titleEs": "Senal de Abril 10",
    "date": "2026-04-20",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_11",
    "src": "/gallery/best/optimized/best-2026-04-11-900.webp",
    "title": "April signal 11",
    "titleEs": "Senal de Abril 11",
    "date": "2026-04-12",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_12",
    "src": "/gallery/best/optimized/best-2026-04-12-900.webp",
    "title": "April signal 12",
    "titleEs": "Senal de Abril 12",
    "date": "2026-04-20",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_13",
    "src": "/gallery/best/optimized/best-2026-04-13-900.webp",
    "title": "April signal 13",
    "titleEs": "Senal de Abril 13",
    "date": "2026-04-20",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_14",
    "src": "/gallery/best/optimized/best-2026-04-14-900.webp",
    "title": "April signal 14",
    "titleEs": "Senal de Abril 14",
    "date": "2026-04-20",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_15",
    "src": "/gallery/best/optimized/best-2026-04-15-900.webp",
    "title": "April signal 15",
    "titleEs": "Senal de Abril 15",
    "date": "2026-04-19",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_16",
    "src": "/gallery/best/optimized/best-2026-04-16-900.webp",
    "title": "April signal 16",
    "titleEs": "Senal de Abril 16",
    "date": "2026-04-12",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_17",
    "src": "/gallery/best/optimized/best-2026-04-17-900.webp",
    "title": "April signal 17",
    "titleEs": "Senal de Abril 17",
    "date": "2026-04-20",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_18",
    "src": "/gallery/best/optimized/best-2026-04-18-900.webp",
    "title": "April signal 18",
    "titleEs": "Senal de Abril 18",
    "date": "2026-04-20",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_19",
    "src": "/gallery/best/optimized/best-2026-04-19-900.webp",
    "title": "April signal 19",
    "titleEs": "Senal de Abril 19",
    "date": "2026-04-12",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_20",
    "src": "/gallery/best/optimized/best-2026-04-20-900.webp",
    "title": "April signal 20",
    "titleEs": "Senal de Abril 20",
    "date": "2026-04-20",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_21",
    "src": "/gallery/best/optimized/best-2026-04-21-900.webp",
    "title": "April signal 21",
    "titleEs": "Senal de Abril 21",
    "date": "2026-04-20",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_22",
    "src": "/gallery/best/optimized/best-2026-04-22-900.webp",
    "title": "April signal 22",
    "titleEs": "Senal de Abril 22",
    "date": "2026-04-20",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_23",
    "src": "/gallery/best/optimized/best-2026-04-23-900.webp",
    "title": "April signal 23",
    "titleEs": "Senal de Abril 23",
    "date": "2026-04-19",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_24",
    "src": "/gallery/best/optimized/best-2026-04-24-900.webp",
    "title": "April signal 24",
    "titleEs": "Senal de Abril 24",
    "date": "2026-04-12",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202604_25",
    "src": "/gallery/best/optimized/best-2026-04-25-900.webp",
    "title": "April signal 25",
    "titleEs": "Senal de Abril 25",
    "date": "2026-04-23",
    "month": "April",
    "monthEs": "Abril",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_01",
    "src": "/gallery/best/optimized/best-2026-02-01-900.webp",
    "title": "February signal 01",
    "titleEs": "Senal de Febrero 01",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_02",
    "src": "/gallery/best/optimized/best-2026-02-02-900.webp",
    "title": "February signal 02",
    "titleEs": "Senal de Febrero 02",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_03",
    "src": "/gallery/best/optimized/best-2026-02-03-900.webp",
    "title": "February signal 03",
    "titleEs": "Senal de Febrero 03",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_04",
    "src": "/gallery/best/optimized/best-2026-02-04-900.webp",
    "title": "February signal 04",
    "titleEs": "Senal de Febrero 04",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_05",
    "src": "/gallery/best/optimized/best-2026-02-05-900.webp",
    "title": "February signal 05",
    "titleEs": "Senal de Febrero 05",
    "date": "2026-02-07",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_06",
    "src": "/gallery/best/optimized/best-2026-02-06-900.webp",
    "title": "February signal 06",
    "titleEs": "Senal de Febrero 06",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_07",
    "src": "/gallery/best/optimized/best-2026-02-07-900.webp",
    "title": "February signal 07",
    "titleEs": "Senal de Febrero 07",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_08",
    "src": "/gallery/best/optimized/best-2026-02-08-900.webp",
    "title": "February signal 08",
    "titleEs": "Senal de Febrero 08",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_09",
    "src": "/gallery/best/optimized/best-2026-02-09-900.webp",
    "title": "February signal 09",
    "titleEs": "Senal de Febrero 09",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_10",
    "src": "/gallery/best/optimized/best-2026-02-10-900.webp",
    "title": "February signal 10",
    "titleEs": "Senal de Febrero 10",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_11",
    "src": "/gallery/best/optimized/best-2026-02-11-900.webp",
    "title": "February signal 11",
    "titleEs": "Senal de Febrero 11",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Natural texture",
    "locationEs": "Textura natural",
    "mood": "quiet detail",
    "moodEs": "detalle tranquilo",
    "description": "A unique nature frame selected for texture, clarity and a calmer visual pause inside the monthly best_moments album.",
    "descriptionEs": "Una toma natural unica elegida por textura, claridad y una pausa visual mas tranquila dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_12",
    "src": "/gallery/best/optimized/best-2026-02-12-900.webp",
    "title": "February signal 12",
    "titleEs": "Senal de Febrero 12",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_13",
    "src": "/gallery/best/optimized/best-2026-02-13-900.webp",
    "title": "February signal 13",
    "titleEs": "Senal de Febrero 13",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_14",
    "src": "/gallery/best/optimized/best-2026-02-14-900.webp",
    "title": "February signal 14",
    "titleEs": "Senal de Febrero 14",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_15",
    "src": "/gallery/best/optimized/best-2026-02-15-900.webp",
    "title": "February signal 15",
    "titleEs": "Senal de Febrero 15",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_16",
    "src": "/gallery/best/optimized/best-2026-02-16-900.webp",
    "title": "February signal 16",
    "titleEs": "Senal de Febrero 16",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_17",
    "src": "/gallery/best/optimized/best-2026-02-17-900.webp",
    "title": "February signal 17",
    "titleEs": "Senal de Febrero 17",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_18",
    "src": "/gallery/best/optimized/best-2026-02-18-900.webp",
    "title": "February signal 18",
    "titleEs": "Senal de Febrero 18",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_19",
    "src": "/gallery/best/optimized/best-2026-02-19-900.webp",
    "title": "February signal 19",
    "titleEs": "Senal de Febrero 19",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_20",
    "src": "/gallery/best/optimized/best-2026-02-20-900.webp",
    "title": "February signal 20",
    "titleEs": "Senal de Febrero 20",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_21",
    "src": "/gallery/best/optimized/best-2026-02-21-900.webp",
    "title": "February signal 21",
    "titleEs": "Senal de Febrero 21",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_22",
    "src": "/gallery/best/optimized/best-2026-02-22-900.webp",
    "title": "February signal 22",
    "titleEs": "Senal de Febrero 22",
    "date": "2026-02-07",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_23",
    "src": "/gallery/best/optimized/best-2026-02-23-900.webp",
    "title": "February signal 23",
    "titleEs": "Senal de Febrero 23",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_24",
    "src": "/gallery/best/optimized/best-2026-02-24-900.webp",
    "title": "February signal 24",
    "titleEs": "Senal de Febrero 24",
    "date": "2026-02-22",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  },
  {
    "id": "BEST_202602_25",
    "src": "/gallery/best/optimized/best-2026-02-25-900.webp",
    "title": "February signal 25",
    "titleEs": "Senal de Febrero 25",
    "date": "2026-02-07",
    "month": "February",
    "monthEs": "Febrero",
    "year": "2026",
    "category": "best_moments",
    "location": "Route archive",
    "locationEs": "Archivo de ruta",
    "mood": "travel fragment",
    "moodEs": "fragmento de viaje",
    "description": "A unique travel frame selected for composition, clarity and route-memory value inside the monthly best_moments album.",
    "descriptionEs": "Una toma de viaje unica elegida por composicion, claridad y valor de memoria de ruta dentro del album mensual best_moments."
  }
]
;

export const bestMomentItems: BestMomentItem[] = rawBestMomentItems.map(({ titleEs, monthEs, locationEs, moodEs, descriptionEs, ...item }) => item);

export function getBestMomentItems(language?: string): BestMomentItem[] {
  if (getSupportedLanguage(language) === "es") {
    return rawBestMomentItems.map((item) => ({
      id: item.id,
      src: item.src,
      title: item.titleEs,
      date: item.date,
      month: item.monthEs,
      year: item.year,
      category: item.category,
      location: item.locationEs,
      mood: item.moodEs,
      description: item.descriptionEs
    }));
  }

  return bestMomentItems;
}
